import { commonTranslationKeys, FieldControllerProps, FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { prefixFieldName } from './common.utils';

type StreetFieldProps = Pick<FormContextValues, 'register'> &
   Pick<FieldControllerProps<'street', string | null>, 'name' | 'required'> &
   ClassNameProp & {
      readonly prefix?: string;
   };

export const StreetField = (props: StreetFieldProps): JSX.Element => {
   const { name, prefix, required, register } = props;
   const fieldName = prefixFieldName(name, prefix);
   return (
      <TextInput
         controller={register(fieldName, {
            maxLength: 50,
            required: required,
         })}
         label={commonTranslationKeys.addressData.street}
         testId={fieldName}
      />
   );
};
